/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

module.exports = {
    /**
     * Audio languages
     */
    audioLanguages: []
};
